<!-- 我的海报 -->
<template>
  <div>
      <van-search class="myposter" @search="search" v-model="searchStr" placeholder="搜索海报" :background="bgcolor ? bgcolor : '#4C5274'"/>
      <div class="poster-tab-view van-hairline--bottom">
        <van-dropdown-menu>
          <van-dropdown-item title="创建时间" v-model="time" :options="option1" @change="changeMenu('time')"/>
          <van-dropdown-item title="浏览量" v-model="pv" :options="option2" @change="changeMenu('pv')"/>
        </van-dropdown-menu>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <postercard v-for="item in dataList" :key="item.id" :item="item" @deleteItem="deleteItem"></postercard>
        </van-list>
        <!-- <div class="van-hairline--bottom poster-view" v-for="(item, index) in dataList" :key="index">
          <van-image class="poster-icon" width="110px" height="110px" radius="10" fit="cover" src="https://img.yzcdn.cn/vant/cat.jpeg" />
          <div class="poster-desc-view">
            <div class="van-multi-ellipsis--l2 poster-title">秋冬面料简约百搭韩版优雅气质展标题两行文</div>
            <div class="poster-sub-text">浏览量：100次</div>
            <div class="poster-select">选择</div>
            <div class="iconfont poster-menu">&#xe693;</div>
          </div>
        </div> -->
        <nodata v-if="dataList.length == 0" msg="还没有我的海报 去制作一个吧"></nodata>
      </van-pull-refresh>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import nodata from '@/components/noData.vue'
import postercard from '../poster/posterCard.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    nodata,
    postercard
  },
  data () {
    // 这里存放数据
    return {
      lock: false,  // 请求锁
      loading: false,
      finished: false,
      isLoading: false,
      pageNum: 1,
      pageRows: 20,
      searchStr: '',
      dataList: [],
      time: '',
      pv: '',
      bgcolor: '',
      option1: [
        { text: '正序', value: 'asc' },
        { text: '倒序', value: 'desc' }
      ],
      option2: [
        { text: '正序', value: 'asc' },
        { text: '倒序', value: 'desc' }
      ]
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 上拉加载
    onLoad() {
      this.getData();
      this.bgcolor = window.bgcolor;
    },
    // 下拉刷新
    onRefresh() {
      this.pageNum = 1;
      this.getData();
    },
    search(value) {
      window.I.$RangersEvent('searchPoster_click');
      this.getData();
    },
    changeMenu(type) {
      if (type == 'time') {
        window.I.$RangersEvent('posterList_creat_time');
        this.pv = '';
      }
      if (type == 'pv') {
        window.I.$RangersEvent('posterList_views');
        this.time = '';
      }
      this.pageNum = 1;
      this.getData();
    },
    getData() {
      var params = {
        pageNum: this.pageNum,
        pageRows: this.pageRows,
        name: this.searchStr,
        createTimeSort: this.time,
        pvSort: this.pv
      }
      if (this.lock) {
        return;
      }
      this.lock = true; // 请求上锁
      this.$http.getPosterPage(params).then(res => {
        this.lock = false;
        this.loading = false;
        this.isLoading = false;
        var data = res.data;
        console.log(data);
        if (this.pageNum == 1) {
          this.dataList = [];
        }
        this.dataList = this.dataList.concat(data.list);
        if (data.list.length == this.pageRows) {
          this.finished = false;
          this.pageNum += 1;
          return;
        }
        this.finished = true;
      }).catch(error => {
        // Dialog({ message: error.data.message });
        this.finished = false;
        this.loading = false;
        this.isLoading = false;
        this.lock = false;
      })
    },
    deleteItem(id) {
      this.dataList = this.dataList.filter(d => {
        return d.id != id;
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getData();
    this.$store.commit('setPrjectData', null);
    window.I.$RangersEvent('myPosterListPage_view');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less">
.van-search__content {
  background-color: #6c708963;
}
</style>
<style lang="less" scoped>
.myposter {
  /deep/ .van-field__control {
    color: #ffffff;
  }
  /deep/ .van-cell {
    color: #4C5274;
  }
}
.poster-view {
  height: 110px;
  background: #FFFFFF;
  padding: 15px;
  display: flex;
}
.poster-icon {
  margin-right: 20px;
  width: 110px;
  height: 110px;
  background: #C9CED6;
  border-radius: 10px;
}
.poster-desc-view {
  flex: 1;
  position: relative;
}
.poster-title {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
}
.poster-menu {
  height: 24.5px;
  line-height: 24.5px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.poster-select {
  height: 24.5px;
  line-height: 24.5px;
  background: #4B5173;
  border-radius: 25px;
  padding: 0px 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  position: absolute;
  bottom: 0px;
  right: 56px;
}
.poster-sub-text {
  margin-top: 5px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.poster-tab-view {
  /* height: 70px; */
  background-color: #fff;
}
.poster-tab {
  text-align: center;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6E7580;
}
</style>